import { Pipe, PipeTransform } from '@angular/core';

import * as HumanDuration from 'human-duration';

@Pipe({
    name: 'humanDuration'
})
export class HumanDurationPipe implements PipeTransform {

    transform(value: any, inputUnit: any = 's', segment: any = null): any {
        let valueAsNumber: number = value as number;
        switch (inputUnit) {
            case 'm':
                valueAsNumber *= 60000;
                break;
            case 's':
                valueAsNumber *= 1000;
                break;
            case 'ms':
                break;
            default:
                throw new Error('Invalid input unit ' + inputUnit);
        }
        const humanDuration = HumanDuration.fmt(valueAsNumber);
        const result: string = segment ? humanDuration.segments(segment).toString() : humanDuration.toString();
        return result;
    }

}
